export const ADDON_KIND = {
  ADDON: 'ADDON',
  SUB_ADDON: 'SUB_ADDON',
} as const;

export type AddonType = (typeof ADDON_KIND)[keyof typeof ADDON_KIND];

export default ADDON_KIND;
